/**
 * FilmIQ Platform v3 - Frontend Configuration
 * 
 * Centralized configuration loader for environment-based settings.
 * All configuration values should be accessed through this module.
 */

// Production identity
export const productionConfig = {
  name: process.env.REACT_APP_PRODUCTION_NAME || 'FilmIQ Production',
  shortName: process.env.REACT_APP_PRODUCTION_SHORT_NAME || 'filmiq',
  studio: process.env.REACT_APP_STUDIO_NAME || '',
};

// API endpoints
export const apiConfig = {
  baseUrl: process.env.REACT_APP_API_URL || '/api',
  copilotUrl: process.env.REACT_APP_COPILOT_API_URL || '/api/copilot/query',
  timeout: parseInt(process.env.REACT_APP_API_TIMEOUT || '30000', 10),
};

// Firebase configuration
export const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || '',
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || '',
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || '',
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || '',
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '',
  appId: process.env.REACT_APP_FIREBASE_APP_ID || '',
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || '',
};

// Feature flags
export const featureFlags = {
  demoMode: process.env.REACT_APP_DEMO_MODE || '',
  debugMode: process.env.REACT_APP_DEBUG_MODE === 'true',
  enableAnalytics: process.env.REACT_APP_ENABLE_ANALYTICS !== 'false',
};

// UI configuration
export const uiConfig = {
  defaultTheme: (process.env.REACT_APP_DEFAULT_THEME as 'light' | 'dark') || 'dark',
  showDebugInfo: process.env.REACT_APP_SHOW_DEBUG_INFO === 'true',
};

// Validate required configuration
export const validateConfig = (): { valid: boolean; errors: string[] } => {
  const errors: string[] = [];
  
  // Firebase is required for authentication
  if (!firebaseConfig.apiKey) {
    errors.push('REACT_APP_FIREBASE_API_KEY is required');
  }
  if (!firebaseConfig.projectId) {
    errors.push('REACT_APP_FIREBASE_PROJECT_ID is required');
  }
  
  return {
    valid: errors.length === 0,
    errors,
  };
};

// Log configuration on startup (non-sensitive values only)
export const logConfig = (): void => {
  if (featureFlags.debugMode) {
    console.group('FilmIQ Configuration');
    console.log('Production:', productionConfig.name);
    console.log('API URL:', apiConfig.baseUrl);
    console.log('Firebase Project:', firebaseConfig.projectId);
    console.log('Demo Mode:', featureFlags.demoMode || 'disabled');
    console.groupEnd();
  }
};

// Default export for convenience
export default {
  production: productionConfig,
  api: apiConfig,
  firebase: firebaseConfig,
  features: featureFlags,
  ui: uiConfig,
  validate: validateConfig,
  log: logConfig,
};
